export const GAME_STATUS_NOT_STARTED = 0;
export const GAME_STATUS_IN_PROGRESS = 1;
export const GAME_STATUS_FINISHED = 2;

export const GAME_KEYCODE_LEFT = 37;
export const GAME_KEYCODE_RIGHT = 39;
export const GAME_KEYCODE_UP = 38;
export const GAME_KEYCODE_DOWN = 40;
